/** Game families resolved automatically from the shared frame. */
export type DetectedPreset = 'mxdc' | 'artale' | 'gcw' | 'worlds'
export const isDetectedPreset = (id: string): id is DetectedPreset => ['mxdc', 'artale', 'gcw', 'worlds'].includes(id)
